"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isoRegexp = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/;
var regExp = /(\d{4})-(\d{2})(?:-(\d{2}))/;
function isDateString(value) {
    return isoRegexp.test(value) || regExp.test(value);
}
exports.isDateString = isDateString;
function parseDate(value) {
    if (!isDateString(value)) {
        return null;
    }
    if (isoRegexp.test(value)) {
        return new Date(Date.parse(value));
    }
    var _a = regExp.exec(value), year = _a[1], month = _a[2], day = _a[3];
    if (day !== undefined) {
        return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
    }
    else {
        return new Date(parseInt(year, 10), parseInt(month, 10) - 1);
    }
}
exports.parseDate = parseDate;
